<template functional>
  <el-submenu :index="props.data.type.toString()">
    <template slot="title">
      <i :class="props.data.icon"></i>
      <span>{{ props.data.name }}</span>
    </template>
    <el-menu-item-group>
      <div v-for="(child, index) in props.data.children" :key="index">
        <div v-if="child.children == undefined">
          <el-menu-item :index="child.type" @click="props.itemClick(child)" :title="child.name">{{
            child.name
          }}</el-menu-item>
        </div>
        <subMenu
          v-else
          :data="child"
          :itemClick="props.itemClick"
          :key="child.type"
        ></subMenu>
      </div>
    </el-menu-item-group>
  </el-submenu>
</template>

<script>
export default {
  name: "submenu",
  props: {
    data: [Array, Object],
    itemClick: [Function],
  },
};
</script>
<style lang="less">
.el-aside {
  .is-opened > .el-submenu__title .el-submenu__icon-arrow {
    -ms-transform: rotate(0deg) !important; /* IE 9 */
    -webkit-transform: rotate(0deg) !important; /* Safari and Chrome */
    transform: rotate(0deg) !important;
    color: rgb(51, 51, 51);
  }

  .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
    -ms-transform: rotate(-90deg); /* IE 9 */
    -webkit-transform: rotate(-90deg); /* Safari and Chrome */
    transform: rotate(-90deg);
    font-size: 16px;
    font-weight: 900;
    color: rgb(51, 51, 51);
  }
}
</style>
